import { ReportModel } from "./ReportModel";

export class FiltroModel {
    filterName: string;
    filterType: string;
    isRequired: boolean;
    filterValue: string;
    report: ReportModel;
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/FiltroModel.ts